import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { Blog } from '../models/blog.model';
import { BlogRepository } from '../repositories/blog.repository';

export class GetBlogsUseCase implements UseCase<void, Blog> {
    constructor(private readonly repository: BlogRepository) {}

    execute(): Observable<Blog> {
        return this.repository.getBlogs();
    }
}
